<template>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ modalTitle }}
                </p>
                <button @click="closeModal" type="button" class="close-icon">
                    <i class="mdi mdi-close"></i>
                </button>
            </header>
            <section class="modal-card-body">
                <div class="columns">
                    <div class="column">
                        <span>The values entered for the collected data under the following criteria has exceeded the maximum value:</span>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <b-table :class="$style.criteriaBasedTable" :data="exceededMaxList">
                            <template slot-scope="props">
                                <b-table-column field="index" label="Data Collection Period Criteria" width="65%">
                                    {{ props.index + 1 }}. {{ props.row.criteriaData.criteria.title }}
                                </b-table-column>
                                <b-table-column label="Max. Value" width="10%">
                                    {{ props.row.maxSampleSize }}
                                </b-table-column>
                                <b-table-column label="Total including your submission">
                                    {{ props.row.currentTotalData }}
                                </b-table-column>
                            </template>
                        </b-table>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <a
                        :class="$style.submitAnywayBtn"
                        @click="submitData"
                >
                    Submit Anyway
                </a>

                <button
                        class="button is-primary is-rounded"
                        @click="closeModal"
                >
                    Cancel
                </button>
            </footer>
        </div>
</template>
<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

    @Component({ components: {
        },
    })
    export default class AuditMinAndMaxErrorModal extends Vue {
        @Prop()
        public modalTitle!: string;

        @Prop()
        public exceededMaxList!: any;

        public closeModal() {
            this.$emit('close');
        }

        public submitData() {
            this.$emit('emitResultData');
            this.$emit('close');
        }
    }
</script>
<style lang="scss" module>
    .submitAnywayBtn {
        color: #00205B;
        font-size: 18px;
        padding-right: 24px;
        font-weight: bold;
    }
    .criteriaBasedTable {
        padding-top: 20px;
    }

    .criteriaBasedTable > div > table {
        border: 1px solid #DFDFDF !important;
        border-radius: 4px !important;
        thead {
            background-color: #FFFFFF;
            tr {
                font-size: 14px;
                th {
                    color: #9F9F9F;
                    font-weight: initial !important;
                    border-bottom: 0.5px solid #DBDBDB;
                    border-right: 0.5px solid #DBDBDB;
                    padding-top: 8px;
                    padding-bottom: 8px;
                }
                th:last-child {
                    border-right: unset;
                }
            }
        }
        tbody {
            background-color: #FFFFFF;
            tr {
                td {
                    color: #444F51;
                    border-bottom: unset;
                    border-right: 0.5px solid #DBDBDB;
                    padding-top: 8px;
                    padding-bottom: 8px;
                    text-align: right;
                }
                td:first-child {
                    text-align: left;
                }
                td:last-child {
                    border-right: unset;
                }
            }
        }
    }
</style>
